import Link from 'next/link';
import { NavigationMobile, NavLink } from './styled';

interface ReloadHandlerProps {
  children: React.ReactNode;
  href: string;
  label: string;
  onClick?: () => void;
  isMobile: boolean;
}

const ReloadHandler = ({
  children,
  href,
  label,
  onClick,
  isMobile,
}: ReloadHandlerProps) => {
  const NavWrapper = isMobile ? NavigationMobile : NavLink;

  return (
    <Link href={href} passHref key={label}>
      {/* @ts-expect-error */}
      <NavWrapper onClick={onClick} key={label}>
        {children}
      </NavWrapper>
    </Link>
  );
};

export default ReloadHandler;
